import { useQuery } from '@tanstack/react-query'
import businessApi from '../api/business.api'
import { QueryKeys } from './querykeys'

export const useMonthlySummary = (
  businessId: number,
  params: { year: number; month?: number; provider?: 'mercadopago' | 'getnet' | 'transbank' },
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: [QueryKeys.GET_MONTHLY_SUMMARY, businessId, params.year, params.month, params.provider],
    gcTime: 10 * 60 * 1000,
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const res = await businessApi.getMonthlySummary(businessId, params)
      return res.data
    },
    enabled: (options?.enabled ?? true) && !!businessId
  })
}
